enum Tabs {
  MYFILES = "my-files", // 我的文件夹
  NOTMYFILES = "not-my-files", // 未添加到文件夹
  SHARE = "space", // 共享文件夹
  SHARES = "shares" // 分享给我的文件
}

const mySpace = [
  {
    title: "myspace.tabs.my-files",
    key: Tabs.MYFILES,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|16"
  },
  {
    title: "myspace.tabs.notadd-files",
    key: Tabs.NOTMYFILES,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|17"
  }
];

const teamSpace = [
  {
    title: "teamspace.tabs.title",
    key: Tabs.SHARE,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|18"
  },
  {
    title: "teamspace.tabs.shared-file",
    key: Tabs.SHARES,
    clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|19"
  }
];

export { mySpace, teamSpace, Tabs };
